export const ErrorCodes = {
    OK: 'OK',
    UNKNOWN: 'UNKNOWN',
    UNCLASSIFIED_ERROR: 'UNCLASSIFIED_ERROR',
    INVALID_LOGIN: 'INVALID_LOGIN',
    ACCOUNT_NOT_FOUND: 'ACCOUNT_NOT_FOUND',
    USER_ACCOUNT_NOT_VERIFIED: 'USER_ACCOUNT_NOT_VERIFIED',
    EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
    TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
    TOO_MANY_RECIPIENTS_EXCEPTION: "TOO_MANY_RECIPIENTS_EXCEPTION",
    REGISTRATION_FAIL_CONTACT_EXISTS: 'REGISTRATION_FAIL_CONTACT_EXISTS',
    INVALID_PASSWORD_EXCEPTION:'INVALID_PASSWORD_EXCEPTION',
    PASSWORD_LENGTH_EXCEPTION:'PASSWORD_LENGTH_EXCEPTION',
    VUMATEL_SERVER_ERROR: 'VUMATEL_SERVER_ERROR',
}

export function createResult(errorCode, data) {
    return {
        code: errorCode,
        data: data
    }
}

export function createCommonResult(response, requestType) {
    console.log("11111 response:", response);
    if (response.code == 'OK')
        return createResult(ErrorCodes.OK, response.data);
    else if (response.code == '429') {
        return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
    } else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.SPENDAMOUNTNOTFULLYCOVEREDEXCEPTION") {
        return createResult(ErrorCodes.SPEND_AMOUNT_NOT_FULLY_COVERED_EXCEPTION, response.error);
    } else if(response.error && (response.error.status === 504 || response.error.status === 500)){
        return createResult(ErrorCodes.VUMATEL_SERVER_ERROR, response.error);
    }
    else {
        return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response);
    }
}